import NewAttachmentInput from './NewAttachmentInput';

export default NewAttachmentInput;
